import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { CommonDataService } from "./../../../common-data.service";
import { environment } from "./../../../../../environments/environment";

@Component({
  selector: "app-member-side-bar",
  templateUrl: "./member-side-bar.component.html",
  styleUrls: ["./member-side-bar.component.scss"],
})
export class MemberSideBarComponent {
  // Inputs from parent (previously accessed via injector)
  @Input() memViewTeam: any;
  @Input() orgId: string = '';
  @Input() currentPg: number = 1;
  @Input() teamsPerPage: number = 20;
  @Input() CommonDataService: CommonDataService;

  // Outputs to parent
  @Output() goToProfile = new EventEmitter<any>();
  @Output() viewBack = new EventEmitter<void>();
  @Output() participantViewEvent = new EventEmitter<{from: string, team: any, member?: any}>();
  @Output() removeTeamMemberEvent = new EventEmitter<any>();
  @Output() addToTeamEvent = new EventEmitter<any>();
  @Output() makeTeamLeadEvent = new EventEmitter<{member: any, roleId: number}>();
  @Output() sortChangeEvent = new EventEmitter<{sortBy: string, sortType: string}>();

  sortType: string = "asc";
  loader: boolean = false;

  constructor(
    private commonService: CommonDataService,
    private router: Router
  ) {
  }

  getSortedData(sortBy: string, sortType: string) {
    this.sortType = sortType;
    this.sortChangeEvent.emit({ sortBy, sortType });
    let sortData: any = this.commonService.sortData(
      `${environment.profileURL}/api/v1/teams/` +
        this.memViewTeam.id +
        `/memberships.json?page=${this.currentPg}&per_page=${this.teamsPerPage}&`,
      sortBy,
      sortType
    );
    sortData.subscribe((res: any) => {
      this.memViewTeam.memberships = res?.memberships;
    });
  }

  goToMemberProfile(member) {
    if (!member?.default_profile?.id) {
      const name = this.CommonDataService?.userName(member, 'first_name') || 'This member';
      Swal.fire({
        icon: 'info',
        title: 'No Profile Available',
        text: `${name} hasn't taken the FourSight assessment yet.`,
        confirmButtonColor: '#69be28'
      });
      return;
    }
    this.goToProfile.emit(member);
  }

  viewChange() {
    this.viewBack.emit();
  }

}
